// Module
var code = "<span *ngIf=\"actionCounterByPriority?.highCount\" class=\"float-right badge badge-danger mx-1\">{{actionCounterByPriority.highCount}}</span> <span *ngIf=\"actionCounterByPriority?.normalCount\" class=\"float-right badge badge-warning mx-1\">{{actionCounterByPriority.normalCount}}</span>";
// Exports
module.exports = code;